import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'campanhaCountLabel'
})
export class CampanhaCountLabelPipe implements PipeTransform {
    transform(count: number): string {
        if (count == null || count === undefined) {
            return '';
        }

        return count == 1 ? 'Campanha' : 'Campanhas';
    }
}
